/**
 * Created by henian.xu on 2018/4/27.
 *
 */

export default {
  namespaced: true,
  modules: {},
};
